import { WindowEvents } from '../analytics/enums/window-events';
import { localStorage } from './browser-features';

const LOCAL_STORAGE_KEY: string = 'planet_window_count';

export class OpenTabsCounter {
    static increment(): number {
        const value: number = OpenTabsCounter.count() + 1;
        localStorage.setItem(LOCAL_STORAGE_KEY, (value).toString(10));
        return value;
    }

    static decrement(): number {
        let value: number = OpenTabsCounter.count() - 1;
        if (value < 0) {
            value = 0;
        }

        localStorage.setItem(LOCAL_STORAGE_KEY, (value).toString(10));
        return value;
    }

    static count(): number {
        const val: string = localStorage.getItem(LOCAL_STORAGE_KEY);
        if (val) {
            return parseInt(val, 10);
        }
        return 0;
    }

    static init(): void {
        OpenTabsCounter.increment();
        window.addEventListener(WindowEvents.BeforeUnload, () => {
            OpenTabsCounter.decrement();
        });
    }
}

